export type WebAppConfig = {
  COMMONEVENT_KINESIS_URL: string;
};

const config: WebAppConfig = require(globals.NODE_ENV === 'production' ? './prod' : './dev').default;

export default config;



// WEBPACK FOOTER //
// ./packages/web-app/src/config/index.ts